function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import path from 'path';
import { WebMobileMode, Platform } from 'domains/constants';
export function getPlatform() {
  if (isTWA()) {
    return Platform.twa;
  }
  // TODO: Revisit this browser check -> part of: https://quintoandar.atlassian.net/browse/DEM-77
  if (process.env.SERVER !== 'true' && navigator.userAgent.includes('Mobi')) {
    return Platform.mobile;
  }
  return Platform.desktop;
}
export var webMobileMode = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(display-mode: standalone)').matches ? WebMobileMode.homescreen : WebMobileMode.browser;
export function getUserPhone(state) {
  if (!state) return null;
  var phone = state.getIn(['login', 'user', 'phone']);
  if (!phone) {
    return null;
  }
  return "".concat(phone.get('countryCode'), " ").concat(phone.get('areaCode'), " ").concat(phone.get('phoneNumber'));
}
export var ID_PREFIX = 892700000;

/* USE CAREFULLY ! APIs should work with both id and code */

/**
 * Converts house code to house id
 *
 * @param  {string} code  The code we want to convert
 *
 * @return {string}       Converted id
 */
export function calculateId(code) {
  var codeNumber = Number(code);
  return String(codeNumber < ID_PREFIX ? ID_PREFIX + codeNumber : codeNumber);
}
export var isEnabled = function isEnabled() {
  try {
    localStorage.setItem('key', '1');
    localStorage.removeItem('key');
    return true;
  } catch (error) {
    return false;
  }
};
export var getKeyFromLocalStorage = function getKeyFromLocalStorage(key) {
  return isEnabled() ? localStorage.getItem(key) : null;
};
export var setKeyToLocalStorage = function setKeyToLocalStorage(key, value) {
  if (isEnabled()) {
    localStorage.setItem(key, value);
  }
};
export var isSwitchedOn = function isSwitchedOn(field) {
  try {
    return localStorage.getItem(field) === JSON.stringify(true);
  } catch (e) {
    return false;
  }
};
export var SwitchOn = function SwitchOn(field) {
  localStorage.setItem(field, true);
};
export var isTWA = function isTWA() {
  if (process.env.SERVER) {
    return false;
  }
  return window.document.referrer === 'android-app://br.com.quintoandar.inquilinos';
};
export var getFileName = function getFileName(filePath) {
  return path.basename(filePath);
};

/* This function creates a pipeline executing a serie of functions in the reverse order of the argument list */
export var compose = function compose() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function (args) {
    return functions.reduceRight(function (arg, fn) {
      return fn(arg);
    }, args);
  };
};
export var getBatchEventsFlag = function getBatchEventsFlag() {
  return process.env.AMPLITUDE_INSTANT_EVENTS !== 'true' && getPlatform() === Platform.mobile;
};
export var isObject = function isObject(value) {
  return !!value && _typeof(value) === 'object' && value.constructor === Object;
};
export var filterPropertiesByPatterns = function filterPropertiesByPatterns(obj) {
  var patterns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!isObject(obj)) return undefined;
  return Object.keys(obj).filter(function (prop) {
    return patterns.every(function (pattern) {
      return !pattern.test(prop);
    });
  }).reduce(function (newObj, prop) {
    return _objectSpread(_objectSpread({}, newObj), {}, _defineProperty({}, prop, obj[prop]));
  }, {});
};